import { registerLocaleData } from '@angular/common';
import localeCL from '@angular/common/locales/es-CL';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {
  ApplicationRef,
  ErrorHandler,
  LOCALE_ID,
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  APP_INITIALIZER,
} from '@angular/core';
import { CambiarClaveUsuarioComponent } from './pages/cambiar-clave-usuario/cambiar-clave-usuario.component';

registerLocaleData(localeCL, 'es-CL');

import { ReactiveFormsModule } from '@angular/forms';
import { SiteMapNavigatorComponent } from './shared/components/site-map-navigator/site-map-navigator.component';
import { WarningMessageComponent } from './shared/components/Warning/warning-message.component';
import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ObserversModule } from '@angular/cdk/observers';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';

import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MAT_DATE_LOCALE } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng2Rut } from 'ng2-rut';
import { NavigationComponent } from './components/navigation/navigation.component';
import { PrintHtmlComponent } from './components/print-html/print-html.component';
import { PrintComponent } from './components/print/print.component';
import { ClaveTemporalComponent } from './pages/clave-temporal/clave-temporal.component';
import { ConfirmModalComponent } from './pages/clave-temporal/components/confirm-modal/confirm-modal.component';
import { FirmaElectronicaComponent } from './pages/firma-electronica/firma-electronica.component';
import { TerminosModalComponent } from './pages/firma-electronica/terminos-modal/terminos-modal.component';
import { IdentifyComponent } from './pages/identify/identify.component';
import { MisDatosComponent } from './pages/mis-datos/mis-datos.component';
import { MisDocumentosComponent } from './pages/mis-documentos/mis-documentos.component';
import { ProductosComponent } from './pages/productos/productos.component';
import { RecuperarClaveComponent } from './pages/recuperar-clave/recuperar-clave.component';
import { DomChangeDirective } from './shared/directives/dom-change.directive';
import { KeepVerticalScrollDirective } from './shared/directives/keep-vertical-scroll.directive';
// import { AngularSvgIconModule } from 'angular-svg-icon';
import { EventsService } from './shared/services/events.service';
import { SessionTimeoutService } from './shared/services/session-timeout.service';
import { SharedModule } from './shared/shared.module';
import { PagarMisProductosComponent } from './pages/pagar-mis-productos/pagar-mis-productos.component';
import { SeguroPrivadoModule } from './modules/seguro-privado/seguro-privado.module';
import { InformeRentabilidadComponent } from './pages/informe-rentabilidad/informe-rentabilidad.component';
import { LogOutComponent } from './pages/log-out/log-out.component';
import { LoginComponent } from './pages/login/login.component';
// import { dsButton } from '../../node_modules/@vs-design-system/ds-button';
// import { SessionModalComponent } from './shared/components/session-modal/session-modal.component';
// import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
//
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { initializer } from '../../src/app/components/utils/app-init';
import { LoginSsoComponent } from './pages/login-sso/login-sso.component';
import { PopUpFirma } from './pages/pop-up-firma/pop-up-firma';
// import { SessionModalComponent } from './shared/components/session-modal/session-modal.component';
// import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import { AppInsightsService } from './shared/services/app-insights-service';
import { PopUpsCuiComponent } from './modules/seguro-individual/pages/tab-administracion/rescates-individual/pop-ups-rescates/pop-ups-cui/pop-ups-cui.component';
import { ComprobanteTokuComponent } from './pages/comprobante-toku/comprobante-toku.component';
import { ModalDynamicModule } from './common/components/modal-dynamic/modal-dynamic.module';

@NgModule({
  declarations: [
    AppComponent,
    ProductosComponent,
    NavigationComponent,
    SiteMapNavigatorComponent,
    WarningMessageComponent,
    ProductosComponent,
    RecuperarClaveComponent,
    PrintComponent,
    PrintHtmlComponent,
    FirmaElectronicaComponent,
    TerminosModalComponent,
    IdentifyComponent,
    MisDatosComponent,
    CambiarClaveUsuarioComponent,
    MisDocumentosComponent,
    DomChangeDirective,
    ClaveTemporalComponent,
    ConfirmModalComponent,
    KeepVerticalScrollDirective,
    PagarMisProductosComponent,
    InformeRentabilidadComponent,
    LogOutComponent,
    LoginComponent,
    AppComponent,
    LoginSsoComponent,
    PopUpFirma,
    PopUpsCuiComponent,
    ComprobanteTokuComponent
  ],
  entryComponents: [
    TerminosModalComponent,
    ConfirmModalComponent,
    PopUpFirma,
    PopUpsCuiComponent,
  ],
  imports: [
    AppRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    Ng2Rut,
    SeguroPrivadoModule,
    MatDialogModule,
    MatDatepickerModule,
    BrowserModule,
    FormsModule,
    PdfViewerModule,
    ModalDynamicModule,
    // NavigationComponent
    KeycloakAngularModule,
    BrowserModule,
    // AngularSvgIconModule
  ],
  providers: [
    EventsService,
    {
      provide: LOCALE_ID,
      useValue: 'es-CL',
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
    SessionTimeoutService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      deps: [KeycloakService],
      multi: true,
    },
    // {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    // {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    AppInsightsService,
    { provide: 'Window', useValue: window },
  ],
  exports: [
    A11yModule,
    BidiModule,
    ObserversModule,
    OverlayModule,
    PlatformModule,
    PortalModule,
    ScrollingModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    NavigationComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
// export class AppModule { }
export class AppModule {
  constructor(public appRef: ApplicationRef) {}
}
// platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
